export default {

  headline: 'Portale per l’assistenza SIEGENIA',
  search_info: 'Cosa state cercando?',
  back: 'indietro',
  no_results: 'Nessun risultato trovato. Si prega di modificare la ricerca',
  service: {
    downloads: 'Download',
    videos: 'Video',
    faq: 'FAQ'
  },
  service_search: {
    category_placeholder: "Filtrare per categoria"
  },
  service_download: {
    select_info: 'Selezionare l’area di ricerca',
    select_productgroup: 'Selezionare l’area prodotto',
    select_product: 'Selezionare il prodotto',
    select_type: 'Selezionare il tipo di documentazione',
    option_language: "linguaggio",
    types: {
      tec_info: 'Informazioni tecniche',
      installation: 'Istruzioni/schemi di montaggio',
      planning: 'Documentazione per la progettazione',
      catalog: 'Broschure',
      order_forms: 'Moduli d‘ordine',
      maintenance: 'Manutenzione, uso, cura',
      construction_drawings: 'Disegni costruttivi',
      software: 'Software',
      certificate: 'Certificati e linee guida',
      press: 'Documentazione per la stampa e il marketing',
      videos: 'Video',
      undefined: 'Altro',
      commercial: 'Spot commerciale',
      product_video: 'Filmato prodotto',
      operating: 'Uso',
      'function': 'Funzionamento',
      'assembly': 'Assemblaggio',
      'installation_video': 'Installazione/Montaggio',
      'assembly_instructions': 'Schema di montaggio',
      'brochure': 'Broschure',
      'tec_catalog': 'Cataloghi tecnici',
      'tec_sheet': 'Schede tecniche',
      'usage_charts': 'Diagrammi di applicazione',
      'profile_sheet': 'Schede tecniche del profilo',
      'operations_manual': 'Istruzioni per l\'uso e la manutenzione',
      hardware_info: 'Informazioni sul montaggio',
      'installation_suggestion' : 'Suggerimento per l\'installazione',
      'general' : 'Generale',
      'troubleshooting' : 'Risoluzione dei problemi',
       "smarthome:general" : 'Generale',
       'smarthome:installation' : 'Installazione',
       'smarthome:troubleshooting' : 'Risoluzione dei problemi',
       'smarthome:startup' : 'Installazione',
       'smarthome:operating' : 'Manuale operativo',
      'order' : 'Ordine',

    },
    filter_sorting: {
      filter: "Filtro",
      sorting: "Ordina",
      asc: "Titolo ascendente (A-Z)",
      desc: "Titolo discendente (Z-A)",
      date_asc: "Prima la data più antica",
      date_desc: "Prima la data più recente",
      relevance: "per importanza",
      facet_headline: "Filtra i risultati della ricerca",
      facet_filter_language: "Lingue",
      facet_filter_type_id: "Tipologia",
      facet_filter_level_0: "Categoria",
      filter_remove: "Azzera il filtro",
      show_hide: "Mostra filtri",
    },
    result: {
      count_media: "Risultati",
      show_results: "Mostra risultati",
      preview_type_catalog: "HTML",
      lang_not_available: "Al momento non disponibile nella vostra lingua",
      version_info: "Questo link porta all'ultima versione della documentazione. Se avete bisogno di una versione precedente, contattate il vostro consulente SIEGENIA."
    }
  }

};
